import { useMemo } from "react";
import Apis from "serviceapi/ApiImports";
import { apisStore } from "context/GlobalStates";
import {
  EasasScheduledTasksApi,
  JobrunnerLogsApi,
  JobsApi,
} from "../../../../serviceapi/jobRunnerApi";

export const useJobRunnerApis = () => {
  const store = apisStore.getState()?.jobRunner;

  const apiScheduled = useMemo(
    () => store?.easasScheduledTasksApi as EasasScheduledTasksApi,
    [store]
  );
  const apiJobs = useMemo(() => store?.jobsApi as JobsApi, [store]);
  const apiJobRunnerLogs = useMemo(
    () => store?.jobrunnerLogsApi as JobrunnerLogsApi,
    [store]
  );
  const managementApi = useMemo(() => Apis("jobrunner").managementApiConst, []);

  return { apiScheduled, apiJobs, apiJobRunnerLogs, managementApi };
};
